var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "22px",
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Unknown / Accessories") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FG2.0-MVP-COMPS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktopexploration_option9",
    transform: "translate(-1320.000000, -1623.000000)",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card-Alignment",
    transform: "translate(415.000000, 1255.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(321.000000, 219.000000)",
    id: "Icons-/-Unknown-/-Accessories"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(584.500000, 148.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.41642869,20.4432808 L8.5,14.7128412 L15.5835713,20.4432808 L15.586427,1.37646988 L1.41642869,1.37231136 L1.41642869,20.4432808 Z M14.942466,21.7144015 L8.5,16.5037769 L2.05753402,21.7144015 C1.24080296,22.3756061 0,21.8114336 0,20.7787347 L0,1.37231136 C0,0.614074681 0.632538216,0 1.41357299,0 L15.586427,0 C16.3674618,0 17,0.614074681 17,1.37231136 L17,20.7801209 C17,21.8128198 15.759197,22.3769923 14.942466,21.7144015 L14.942466,21.7144015 Z",
    id: "Bookmarks",
    fill: "#0562D2"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.6a036a6e946d9b5983a268240505063d.svg";
export { ForwardRef as ReactComponent };